export const SettingsViewGrid = {
	size: 100,
	gap: 1,
	name: 'SettingsViewGrid',
	padding: {
		top: 5,
		bottom: 5,
		left: 5,
		right: 5,
		landscape: {
			top: 3,
			bottom: 0,
			left: 5,
			right: 5
		},
		portrate: {
			top: 3,
			bottom: 3,
			left: 3,
			right: 3
		}
	},
	main: [
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'leftgrid',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'leftgrid',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 15
					},
					{
						name: 'settings_view_holder_up',
						bounds: {
							width: 1144,
							height: 680
						},
						// height: 90,
						size: 75
					}
				]
			}
		},
		{
			name: 'empty',
			size: 27
		}
	]
};
